import React from "react";
import "./styles.scss";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Button, ButtonColour, ButtonSize } from "@trussle/external-components";
import { IContentfulHeroProps } from "../../types/IHero";
import { trackEvent } from "../../helpers/analytics";
import { ChecklistCard } from "./ChecklistCard";
import { PanelWrapper } from "../PanelWrapper";
import { LayoutTwoElements } from "../Layouts/LayoutTwoElements";

const HeroChecklist: React.FC<IContentfulHeroProps> = ({
  heading1,
  bulletsTitle,
  bullets,
  firstCta
}) => {
  const handleCtaClick = async () => {
    await trackEvent("HeroChecklist CTA clicked", {
      module: "HeroChecklist",
      element_type: "Button",
      section: "Megabutton"
    });

    window.location.assign(firstCta?.url ?? "/get-started");
  };

  const LeftElement = (
    <section className="hero-checklist__heading" aria-label="Hero heading">
      <div className="hero-checklist__title">
        {heading1 && renderRichText(heading1)}
      </div>
      <Button
        classOverrides={{ button: "hero-checklist__cta" }}
        testIds={{ button: "hero-checklist-cta" }}
        onClick={handleCtaClick}
        size={ButtonSize.Large}
        colour={ButtonColour.Black}
      >
        {firstCta?.title ?? "Get started"}
      </Button>
    </section>
  );

  const RightElement = (
    <ChecklistCard title={bulletsTitle ?? ""} items={bullets ?? []} />
  );

  return (
    <PanelWrapper isBetterV2 backgroundSideShapes="purple">
      <LayoutTwoElements
        firstElement={LeftElement}
        firstElementFlex={4}
        secondElement={RightElement}
        secondElementFlex={6}
      />
    </PanelWrapper>
  );
};

export default HeroChecklist;
